import React from 'react'

type BadgeVariant = 'default' | 'active' | 'pending' | 'complete' | 'urgent' | 'premium' | 'live'

interface BadgeProps {
  variant?: BadgeVariant
  children: React.ReactNode
  pulse?: boolean
}

const variants: Record<BadgeVariant, string> = {
  default: 'bg-surface-overlay text-text-secondary border-surface-border',
  active: 'bg-brand-accent/10 text-brand-accent border-brand-accent/30',
  pending: 'bg-brand-warning/10 text-brand-warning border-brand-warning/30',
  complete: 'bg-brand-success/10 text-brand-success border-brand-success/30',
  urgent: 'bg-brand-danger/10 text-brand-danger border-brand-danger/30',
  premium: 'bg-brand-premium/10 text-brand-premium border-brand-premium/30',
  live: 'bg-brand-highlight/10 text-brand-highlight border-brand-highlight/30',
}

export function Badge({ variant = 'default', children, pulse = false }: BadgeProps) {
  return (
    <span className={`
      inline-flex items-center gap-1.5 px-2.5 py-0.5
      text-xs font-semibold rounded-full border
      ${variants[variant]}
    `}>
      {pulse && (
        <span className="relative flex h-1.5 w-1.5">
          <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${variant === 'live' ? 'bg-brand-highlight' : 'bg-current'}`} />
          <span className={`relative inline-flex rounded-full h-1.5 w-1.5 ${variant === 'live' ? 'bg-brand-highlight' : 'bg-current'}`} />
        </span>
      )}
      {children}
    </span>
  )
}
